import { defineComponent as _defineComponent } from 'vue'
import StateChip from '@/components/StateChip.vue';
import { SdsesFilterParams, UseSdsFilter } from '@/composables/useSdsFilter';
import { UnwrapRef } from 'vue';
import sharedMessages from '@/lib/shared-messages';

type StateList = UnwrapRef<UseSdsFilter['statusOptions']>;
type StatusFilterValue = SdsesFilterParams['statusGroupId'];


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectStatus',
  props: {
    selectList: null,
    selectValue: null,
    currentFilteredStatus: null,
    filterPanelStatusLabel: null
  },
  emits: ["handleInput", "handleRemove"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'handleInput', value: StatusFilterValue): void;
  (e: 'handleRemove', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  selectList: StateList;
  selectValue: StatusFilterValue;
  currentFilteredStatus: StateList;
  filterPanelStatusLabel: string;
};





return { __sfc: true,props, emits, StateChip, sharedMessages }
}

})